import React from "react";
import { Skeleton } from "antd";

export const CompaniesCardLoading = () => {
  return (
    <div
      style={{
        width: "100%",
        background: "#fff",
        borderRadius: 10,
        border: "1px solid #e7e7e7",
        display: "flex",
        alignItems: "center",
        padding: 10,
        flexDirection: "column",
        cursor: "pointer",
      }}
    >
      {/* <Skeleton.Input active size={32} style={{ width: 200, marginBottom: 8 }} /> */}
      {/* <Skeleton.Input
        active
        block
        style={{
          // width: "265px",
          height: "80px",
          borderRadius: 5,
        }}
      /> */}
      <Skeleton.Button
        active
        style={{
          width: "80px",
          height: "80px",
          borderRadius: 100,
          marginTop: 10,
        }}
      />

      <Skeleton
        active
        style={{
          // width: "265px",
          height: "15px",
          borderRadius: 15,
          marginTop: 20,
        }}
      />
    </div>
  );
};
